<template>
  <div>
    <b-container fluid>
      <h1>システム構成</h1>
      <b-form-group
        label="システム構成No."
        label-cols="3"
        label-for="system_config_no"
        label-align="left"
        required
      >
        <b-form-select
          id="system_config_no"
          v-model="system_config_no"
          :options="system_config_no_options"
          @input="changeSystemConfigNo"
          number
        ></b-form-select>
        <b-form-invalid-feedback id="system_config_no" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
        <b-row align-h="end">
          <template>
            <b-button variant="outline-secondary" @click="newSystemConfig">新規</b-button>
          </template>
          <template>
            <b-button variant="outline-secondary" @click="removeSystemConfig">削除</b-button>
          </template>
        </b-row>
      </b-form-group>
      <b-form-group
        label="冷媒系統/コントローラー系統"
        label-cols="3"
        label-for="type"
        label-align="left"
        required
      >
        <b-form-select id="type" v-model="type" :options="type_options" @input="changeType"></b-form-select>
      </b-form-group>
      <b-form-group label="アドレス" label-cols="3" label-for="address_no" label-align="left" required>
        <b-form-select
          id="address_no"
          v-model="address_no"
          :options="address_options"
        ></b-form-select>
      </b-form-group>
      <b-container v-show="image_visible">
        <b-row align-h="center">
          <div id="base_system_config">
            <img src="../../../assets/system_structure.png" id="system_structure_image" />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].oc"
              value="oc"
              aria-label
              type="checkbox"
              id="address_oc"
              @click="checkValue('oc')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].oc_adp1"
              value="oc_adp1"
              aria-label
              type="checkbox"
              id="address_oc_adp1"
              @click="checkValue('oc_adp1')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].oc_adp2"
              value="oc_adp2"
              aria-label
              type="checkbox"
              id="address_oc_adp2"
              @click="checkValue('oc_adp2')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic1"
              value="ic1"
              aria-label
              type="checkbox"
              id="address_ic1"
              @click="checkValue('ic1')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic1_adp1"
              value="ic1_adp1"
              aria-label
              type="checkbox"
              id="address_ic1_adp1"
              @click="checkValue('ic1_adp1')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic1_adp2"
              value="ic1_adp2"
              aria-label
              type="checkbox"
              id="address_ic1_adp2"
              @click="checkValue('ic1_adp2')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic2"
              value="ic2"
              aria-label
              type="checkbox"
              id="address_ic2"
              @click="checkValue('ic2')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic2_adp1"
              value="ic2_adp1"
              aria-label
              type="checkbox"
              id="address_ic2_adp1"
              @click="checkValue('ic2_adp1')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic2_adp2"
              value="ic2_adp2"
              aria-label
              type="checkbox"
              id="address_ic2_adp2"
              @click="checkValue('ic2_adp2')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic3"
              value="ic3"
              aria-label
              type="checkbox"
              id="address_ic3"
              @click="checkValue('ic3')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic3_adp1"
              value="ic3_adp1"
              aria-label
              type="checkbox"
              id="address_ic3_adp1"
              @click="checkValue('ic3_adp1')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic3_adp2"
              value="ic3_adp2"
              aria-label
              type="checkbox"
              id="address_ic3_adp2"
              @click="checkValue('ic3_adp2')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic4"
              value="ic4"
              aria-label
              type="checkbox"
              id="address_ic4"
              @click="checkValue('ic4')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic4_adp1"
              value="ic4_adp1"
              aria-label
              type="checkbox"
              id="address_ic4_adp1"
              @click="checkValue('ic4_adp1')"
            />
            <input
              v-model="system_config_data[system_config_no - 1][address_no].ic4_adp2"
              value="ic4_adp2"
              aria-label
              type="checkbox"
              id="address_ic4_adp2"
              @click="checkValue('ic4_adp2')"
            />
          </div>
        </b-row>
      </b-container>
      <b-container v-show="rc_visible">
        <b-form-group label-cols="3" label-for="rc" label-align="right" label="コントローラー">
          <b-form-checkbox id="rc" v-model="system_config_data[system_config_no - 1][address_no].rc" @input="changeRc('rc')"></b-form-checkbox>
        </b-form-group>
      </b-container>
      <b-container v-show="table_visible">
        <b-table border :items="table_items" :fields="table_fields"></b-table>
      </b-container>
    </b-container>
    <b-row align-h="center">
      <template>
        <b-button variant="outline-secondary" @click="createSystemConfig">保存</b-button>
      </template>
      <button @click="displayResumeModal = !displayResumeModal" class="btn btn-outline-secondary">戻る</button>
      <b-modal v-model="displayResumeModal" hide-footer>
        <b-row align-h="around">
          <p>移動してよろしいですか？</p>
        </b-row>
        <b-row align-h="around">
          <button class="btn btn-outline-secondary" @click="pageBack">はい</button>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-row>
  </div>
</template>
<script>
import convertBackToFront from '../../../utils/convertSystemConfigBackToFront'
import checkValue from '../../../utils/checkValue'
import convertFrontToBack from '../../../utils/convertSystemConfigFrontToBack'
import convertTableData from '../../../utils/convertSytemConfigTableData'
import skelton from '../../../utils/DefaultSystemConfigFrontendData.json'
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'SystemConfig',
  data () {
    return {
      system_config_no: 1,
      system_config_no_options: [],
      type: 'refregerant',
      address_no: 0,
      type_options: [
        {
          value: 'refregerant',
          text: '冷媒系統'
        },
        {
          value: 'controller',
          text: 'コントローラー系統'
        }
      ],
      system_config_data: [
        [
          {
            oc: '',
            oc_adp1: '',
            oc_adp2: '',
            ic1: '',
            ic1_adp1: '',
            ic1_adp2: '',
            ic2: '',
            ic2_adp1: '',
            ic2_adp2: '',
            ic3: '',
            ic3_adp1: '',
            ic3_adp2: '',
            ic4: '',
            ic4_adp1: '',
            ic4_adp2: ''
          }
        ]
      ],
      display_refrege_data: {},
      table_visible: true,
      image_visible: true,
      rc_visible: false,
      address_options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      table_fields: [
        {
          key: 'system_config_no',
          label: 'システムNo.'
        },
        {
          key: 'type',
          label: '系統'
        },
        {
          key: 'address',
          label: 'アドレス'
        },
        {
          key: 'OC',
          label: 'OC'
        },
        {
          key: 'OC_ADP',
          label: 'OC(ADP)'
        },
        {
          key: 'IC',
          label: 'IC'
        },
        {
          key: 'IC_ADP',
          label: 'ADP(IC)'
        },
        {
          key: 'RC',
          label: 'RC'
        }
      ],
      table_items: [
        {
          system_config_no: 1,
          type: 'refregrant',
          address: 0,
          OC: 'OC',
          ADP_OC: 'ADP1',
          IC: 'IC',
          ADP_IC: 'IC1',
          RC: 'RC'
        }
      ],
      result: {},
      displayResumeModal: false
    }
  },
  methods: {
    pageBack () {
      this.$router.go(-1)
    },
    changeSystemConfigNo () {
      if (this.system_config_no === '') {
        this.system_config_no = 1
      }
    },
    newSystemConfig () {
      const systemConfigData = JSON.parse(JSON.stringify(skelton))
      this.system_config_data.push(systemConfigData)
      this.system_config_no_options.push(this.system_config_data.length)
      this.system_config_no = this.system_config_data.length
      this.makeToast('成功', `システム構成No.${this.system_config_no}を作成しました`, 'info')
    },
    async removeSystemConfig () {
      if (this.system_config_no_options.length === 1) {
        this.makeToast('失敗', 'これ以上削除できません', 'danger')
        return
      }
      await API.graphql(graphqlOperation(`
        mutation deleteSystemConfig {
          deleteSystemConfig (no: ${this.system_config_no}) {
            config
          }
        }
      `))
      this.makeToast('成功', `システム構成No.${this.system_config_no}を削除しました`, 'info')
      // ここから初期化
      const tempSystemConfigData = await this.listSystemConfig()
      const initSystemConfigData = tempSystemConfigData.data.listSystemConfig.items
      this.system_config_data = initSystemConfigData.map(elm => {
        const parsedData = convertBackToFront(elm)
        return parsedData
      })
      const tempTableItems = this.system_config_data.map((_, index) => {
        return convertTableData(
          this.system_config_data[index],
          index + 1
        )
      })
      this.table_items = tempTableItems.reduce((acc, cur) => {
        return acc.concat(cur)
      }, [])
      const systemNoList = []
      for (let i = 0; i < initSystemConfigData.length; i++) {
        systemNoList.push(i + 1)
      }
      this.system_config_no_options = systemNoList
      this.system_config_no = this.system_config_no - 1
    },
    async createSystemConfig () {
      await this.system_config_data.forEach(async (elm, index) => {
        const result = convertFrontToBack(elm)
        const res = await API.graphql(graphqlOperation(`
          mutation updateSystemConfig {
            updateSystemConfig (
              no: ${index + 1}
              config: "${JSON.stringify(result).split('"').join('\\"')}"
            ) {
              config
            }
          }
        `))
        this.$log.debug(res)
        this.makeToast('成功', 'システム構成を保存しました。', 'info')
      })
    },
    changeType () {
      if (this.type === 'refregerant') {
        this.image_visible = true
        this.rc_visible = false
      } else {
        this.image_visible = false
        this.rc_visible = true
      }
    },
    changeRc (source) {
      let target = this.system_config_data[this.system_config_no - 1][this.address_no][source]
      if (target) {
        target = true
      } else {
        target = false
      }
      const tempTableItems = this.system_config_data.map((_, index) => {
        return convertTableData(
          this.system_config_data[index],
          index + 1
        )
      })
      this.table_items = tempTableItems.reduce((acc, cur) => {
        return acc.concat(cur)
      }, [])
    },
    checkValue (source) {
      const target = this.system_config_data[this.system_config_no - 1][this.address_no]
      const action = target[source] ? 'off' : 'on'
      if (action === 'off') {
        target[source] = false
      } else {
        target[source] = true
      }
      checkValue(target, action, source)
      const tempTableItems = this.system_config_data.map((_, index) => {
        return convertTableData(
          this.system_config_data[index],
          index + 1
        )
      })
      this.table_items = tempTableItems.reduce((acc, cur) => {
        return acc.concat(cur)
      }, [])
    },
    async listSystemConfig () {
      const tempSystemConfigData = await API.graphql(graphqlOperation(`
        query listSystemConfig {
          listSystemConfig {
            items {
              config
            }
          }
        }
      `))
      return tempSystemConfigData
    }
  },
  async created () {
    const tempSystemConfigData = await this.listSystemConfig()
    if (tempSystemConfigData.data.listSystemConfig === null) {
      const systemConfigData = JSON.parse(JSON.stringify(skelton))
      this.system_config_data = [systemConfigData]
      this.system_config_no_options = [1]
      this.system_config_no = this.system_config_data.length
      this.makeToast('成功', `システム構成No.${this.system_config_no}を作成しました`, 'info')
      return
    }
    const initSystemConfigData = tempSystemConfigData.data.listSystemConfig.items
    this.system_config_data = initSystemConfigData.map(elm => {
      const parsedData = convertBackToFront(elm)
      return parsedData
    })
    const tempTableItems = this.system_config_data.map((_, index) => {
      return convertTableData(
        this.system_config_data[index],
        index + 1
      )
    })
    this.table_items = tempTableItems.reduce((acc, cur) => {
      return acc.concat(cur)
    }, [])
    const systemNoList = []
    for (let i = 0; i < initSystemConfigData.length; i++) {
      systemNoList.push(i + 1)
    }
    this.system_config_no_options = systemNoList
  },
  computed: {
    systemConfigValidater () {
      return true
    }
  }
}
</script>
<style>
#base_system_config {
  width: 600px;
  overflow-x: scroll;
  position: relative;
}
#system_structure_image {
  width: 100%;
}
#address_oc {
  position: absolute;
  top: 19.9%;
  left: 0.7%;
}
#address_oc_adp1 {
  position: absolute;
  top: 0.7%;
  left: 0.7%;
}
#address_oc_adp2 {
  position: absolute;
  top: 0.7%;
  left: 18%;
}
#address_ic1 {
  position: absolute;
  top: 52%;
  left: 0.7%;
}
#address_ic1_adp1 {
  position: absolute;
  top: 71.6%;
  left: 11%;
}
#address_ic1_adp2 {
  position: absolute;
  top: 87.9%;
  left: 11%;
}
#address_ic2 {
  position: absolute;
  top: 52%;
  left: 25.5%;
}
#address_ic2_adp1 {
  position: absolute;
  top: 71.6%;
  left: 35.7%;
}
#address_ic2_adp2 {
  position: absolute;
  top: 87.9%;
  left: 35.7%;
}
#address_ic3 {
  position: absolute;
  top: 52%;
  left: 50.2%;
}
#address_ic3_adp1 {
  position: absolute;
  top: 71.6%;
  left: 60.3%;
}
#address_ic3_adp2 {
  position: absolute;
  top: 87.9%;
  left: 60.3%;
}
#address_ic4 {
  position: absolute;
  top: 52%;
  left: 74.7%;
}
#address_ic4_adp1 {
  position: absolute;
  top: 71.6%;
  left: 85.2%;
}
#address_ic4_adp2 {
  position: absolute;
  top: 87.9%;
  left: 85.2%;
}
</style>
